// extracted by mini-css-extract-plugin
export default {"reactSelectContainer":"customers_reactSelectContainer__vEZuu","modal_root":"customers_modal_root__q62+I","modal_sticky_body":"customers_modal_sticky_body__WXWb4"};